import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconGutterVertical20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconGutterVertical20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.5 3.75a.75.75 0 0 0-1.5 0V4a2.5 2.5 0 0 0 2.5 2.5h9.002a2.5 2.5 0 0 0 2.5-2.5v-.25a.75.75 0 0 0-1.5 0V4a1 1 0 0 1-1 1H5.5a1 1 0 0 1-1-1zM5.004 10a.75.75 0 0 1 .75-.75h8.496a.75.75 0 0 1 0 1.5H5.754a.75.75 0 0 1-.75-.75m11.248 7.002a.75.75 0 0 1-.75-.75v-.25a1 1 0 0 0-1-1H5.5a1 1 0 0 0-1 1v.25a.75.75 0 1 1-1.5 0v-.25a2.5 2.5 0 0 1 2.5-2.5h9.002a2.5 2.5 0 0 1 2.5 2.5v.25a.75.75 0 0 1-.75.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconGutterVertical20);
